<template>
  <div>
    <el-dialog
      title="消息订阅"
      :visible.sync="dialogFormVisible"
      width="700px"
      :close-on-click-modal="false"
      @close="emitClose"
    >
      <el-form
        :model="dataForm"
        label-position="right"
        ref="formRules"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="关键词：">
          <el-tag
            :key="tag"
            v-for="tag in keywordsTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag,'keywordsTags')"
          >
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="keywordsTagsVisible"
            v-model="keywordsTagsValue"
            ref="keywordsTags"
            @keyup.enter.native="handleKeywordsTagsConfirm"
            @blur="handleKeywordsTagsConfirm"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showKeywordsTagsVisible"
          >添加关键词</el-button>
        </el-form-item>
        <el-form-item label="标签：">
          <el-tag
            :key="tag"
            v-for="tag in labelTags"
            closable
            type="success"
            :disable-transitions="false"
            @close="handleClose(tag,'labelTags')"
          >
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="labelTagsVisible"
            v-model="labelTagsValue"
            ref="labelTags"
            @keyup.enter.native="handleLabelTagsConfirm"
            @blur="handleLabelTagsConfirm"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showLabelTagsVisible"
          >添加标签</el-button>
        </el-form-item>
        <el-form-item
          label="分类："
          prop="category_id"
        >
          <el-select
            v-model="dataForm.category_id"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="来源："
          prop="origin"
        >
          <el-input
            style="width:100%;"
            v-model="dataForm.origin"
            placeholder="请输入来源"
          ></el-input>
        </el-form-item>
        <el-form-item label="接收人：">
          <el-select
            v-model="dataForm.subscribers_"
            placeholder="请输入员工姓名/手机号"
            clearable
            filterable
            remote
            multiple
            :remote-method="remoteMethod"
            :loading="loading"
            style="width:100%;"
          >
            <el-option
              v-for="(item,index) in adminlist"
              :key="index"
              :label="item.nickname"
              :value="item.id"
            >
              <span>{{item.nickname}}/{{item.mobile}}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="tips">
            提示：以上条件至少填一个，同时填写后仅全部满足才会推送！
          </div>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="emitClose">取 消</el-button>
        <el-button
          type="primary"
          @click="submit('formRules')"
        >确 定</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>


import {
  articleCategoryList,
} from "@/api/article";
import {
  subscribeEdit,
  articlesubscribeOne,
} from "@/api/news";

export default {
  components: {

  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      dataForm: {},
      dialogFormVisible: this.isVisible,
      rules: {
      },
      loading: false,
      categorys: [],
      keywordsTags: [],// 关键词标签数组
      keywordsTagsVisible: false,
      keywordsTagsValue: '',
      labelTags: [],// ‘标签’标签数组
      labelTagsVisible: false,
      labelTagsValue: '',
      adminlist: [],
    };
  },
  mounted() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
      if (val) {
        this.fetchCategoryList()
        this.fetchDetail()
      }

    },

  },
  methods: {
    fetchDetail() {
      articlesubscribeOne({ id: this.id }).then((res) => {
        this.dataForm.id = res.id
        this.keywordsTags = res.keywords ? res.keywords.split(',') : []
        this.labelTags = res.tags ? res.tags.split(',') : []
        this.$set(this.dataForm, 'category_id', res.category_id)
        this.$set(this.dataForm, 'origin', res.origin)
        /*  this.dataForm.category_id = res.category_id
         this.dataForm.origin = res.origin */


        this.$set(this.dataForm, 'subscribers_', res.subscribers.map(v => { return Number(v.id) }))
        this.adminlist = res.subscribers
        this.$forceUpdate()
      });
    },
    emitClose() {
      this.dataForm = {}
      this.$emit("close");
    },
    // 分类列表请求
    fetchCategoryList() {
      articleCategoryList({ isPaging: 0 }).then((res) => {
        this.categorys = res.list;
      });
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let query = {
            id: this.dataForm.id,
            keywords: this.keywordsTags.length ? this.keywordsTags.join(',') : "",
            tags: this.labelTags.length ? this.labelTags.join(',') : "",
            category_id: this.dataForm.category_id ? this.dataForm.category_id : null,
            origin: this.dataForm.origin,
            subscribers: this.dataForm.subscribers_.length ? this.dataForm.subscribers_.join(',') : "",
          }
          subscribeEdit(query).then((res) => {
            this.$message.success('提交成功')
            this.$emit('submit')
            this.emitClose()
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleKeywordsTagsConfirm() {
      let inputValue = this.keywordsTagsValue;
      if (inputValue) {
        this.keywordsTags.push(inputValue);
      }
      this.keywordsTagsVisible = false;
      this.keywordsTagsValue = '';
    },
    showKeywordsTagsVisible() {
      this.keywordsTagsVisible = true;
      this.$nextTick(_ => {
        this.$refs.keywordsTags.$refs.input.focus();
      });
    },
    handleLabelTagsConfirm() {
      let inputValue = this.labelTagsValue;
      if (inputValue) {
        this.labelTags.push(inputValue);
      }
      this.labelTagsVisible = false;
      this.labelTagsValue = '';
    },
    showLabelTagsVisible() {
      this.labelTagsVisible = true;
      this.$nextTick(_ => {
        this.$refs.labelTags.$refs.input.focus();
      });
    },
    handleClose(tag, name) {
      switch (name) {
        case 'keywordsTags':
          this.keywordsTags.splice(this.keywordsTags.indexOf(tag), 1);
          break;
        case 'labelTags':
          this.labelTags.splice(this.labelTags.indexOf(tag), 1);
          break;
        default:
          break;
      }
    },
    remoteMethod(query) {
      if (query != "") {
        this.$store.dispatch('getAdminList', { keyword: query })
        setTimeout(() => {
          this.adminlist = this.$store.state.adminList
        }, 500);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.input-new-tag {
  width: 90px;
}
.el-tag {
  line-height: 32px;
  height: 32px;
  margin: 0px 5px;
}
.tips {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
}
</style>